// JS for the long form content style of template // Only load functions if necessary
if(document.getElementById("article-tags-heading")) {
  articleJumpLinks();
}
if(document.getElementById('mega-menu')) {
  megaMenuController();
}
if(document.getElementById('medically-reviewed')) {
  medicalReviewToggle();
}
// This might move to a more general function...
if(document.getElementById('attention-banner')) {
  topBanner = document.getElementById("attention-banner");
  window.addEventListener('scroll', topBannerController);
}

function topBannerController() {
  if(window.innerWidth > 768) {
    return;  
  }
  if(window.scrollY > 180) {
    topBanner.classList.add("sticky-on")
  }
  if(window.scrollY < 180) {
    topBanner.classList.remove("sticky-on")
  }
}

function medicalReviewToggle() {
  // set-up and gatekeep
  const popUpWrapper = document.getElementById('medically-reviewed-popup-wrapper');
  const popUpToggle = document.getElementById('medically-reviewed');
  const popUpClose = document.getElementById('medically-reviewed-popup__close');
  if (!popUpWrapper || !popUpToggle || !popUpClose) {
    return;
  }
  popUpToggle.addEventListener('click', function(e) {
    e.preventDefault;
    popUpWrapper.classList.toggle('medically-reviewed-popup-wrapper__visible')
  })
  popUpClose.addEventListener('click', function(e) {
    e.preventDefault;
    popUpWrapper.classList.remove('medically-reviewed-popup-wrapper__visible')
  })
}

function megaMenuController() {
  const mainTrigger = document.getElementById("main-button");
  mainTrigger.addEventListener("click", trigger)
  
  const triggers = document.getElementsByClassName("trigger");
  const windows = document.getElementsByClassName("window");
  for(let i = 0; i < triggers.length; i++) {
    triggers[i].dataset.order = [i]
    triggers[i].addEventListener("click", funcTriggers)
  }  
  function trigger(e) {
    e.target.classList.toggle('open')
  }

  function funcTriggers(e) {
    megaMenuController(e, triggers, windows);
  }
  function megaMenuController(e, triggers, windows) {
    const triggeredEl = e.target;
    const intendedWindow = windows[triggeredEl.dataset.order];
    triggeredEl.classList.toggle("open")
    intendedWindow.classList.toggle("open")
    for(let i = 0; i < triggers.length; i++) { 
      if (triggers[i].dataset.order == triggeredEl.dataset.order) {
        continue
      }
      triggers[i].classList.remove("open");
    }
    for(let j = 0; j < windows.length; j++) {
      if ( j == triggeredEl.dataset.order) {
        continue
      }
      windows[j].classList.remove("open")
    }
  }
}
 
function articleJumpLinks() {
  // Set Up toggle function // Only necessary if three items exist: 
  const headers = document.querySelectorAll('article h2');
  const tagSystemHeading = document.getElementById('article-tags-heading');
  const tagContainer = document.getElementById('article-tags');
  const tagWrapper = document.getElementById('article-tags-wrapper');
  const tagToggle = document.getElementById('article-tags-toggle');
  
  // Gatekeeping
  if(!tagToggle || !tagContainer || !tagSystemHeading || !tagWrapper) {
    return;
  }

  // Gatekeeping
  if(headers.length == 0) {
    tagSystemHeading.style.display = "none";
    tagSystemHeading.style.padding = 0;
    tagContainer.style.display = "none";
    tagWrapper.style.display = "none";
    tagToggle.style.display = "none";
    return;
  }

  // Add Toggle for menu system
  tagToggle.addEventListener('click', function(e) {
    e.preventDefault();
    tagContainer.classList.toggle('article-tag__toggled');
    tagWrapper.classList.toggle('__toggled');
  })

  // Clean up h2 Id's and then add them to container
  for (let i = 0; i < headers.length; i++) {
    const header = headers[i];

    if (!header.id) {
        header.id = generateIdFromText(header.innerText || header.textContent);
    }

    // Create a new tag element
    let newTag = document.createElement('a');
    newTag.className = 'article-tag';
    newTag.href = '#' + header.id; // Link to the header ID
    newTag.textContent = header.textContent.trim(); // Use header text for the tag

    // Append the new tag to the container 
    tagContainer.appendChild(newTag);
    }
}

//Utility Function
function generateIdFromText(text) {
  // Helper function for IDs
  return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
      .replace(/^-+|-+$/g, '')     // Remove leading/trailing hyphens
      .substring(0, 50);           // Limit ID length to 50 characters
}



/* Future
$('.next-menu-show-more').click(function (e) {
  e.preventDefault();
  $(this).toggleClass('next-menu-show-more__toggled');
  var container = $('.next-menu-list');
  container.toggleClass('next-menu-list__toggled');
});
*/
